import Accordion from 'accordion-js';

const accordions = Array.from(document.querySelectorAll('.js-accordionWithSubsections'));

accordions.forEach(accordion => {
	new Accordion(accordion, {
		elementClass: 'js-accordionElement',
		triggerClass: 'js-accordionTrigger',
		panelClass: 'js-accordionPanel',
		activeClass: 'is-active',
		showMultiple: true,
	});
});
